import React from "react"
import propTypes from "prop-types"

const Title = ({ children }) => {
  return <div className="answer_title">{children}</div>
}

Title.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired
}

export default Title
